import { Grid, Button } from "@material-ui/core";
import dashedButtonStyle from "styles/buttons/dashed-button.module.scss";
import AddIcon from "@material-ui/icons/Add";
import React, { useEffect, useState } from "react";
import { CustomCTADialog } from "./custom-cta-dialog";
import { CustomCTA as CUSTOMCTA, GetUrlBuilderData } from "store/url-builder";
import { useSelector } from "react-redux";
import roundedButtonStyle from "styles/buttons/rounded-button.module.scss";
import { isWhite } from "utils";

export interface CustomCTAProps {
  builderType: string;
}

export const CustomCTA = ({ builderType }: CustomCTAProps) => {
  const [openDialog, setOpenDialog] = useState(false);
  const builderData = useSelector(GetUrlBuilderData);

  const [ctaList, setCtaList] = useState<CUSTOMCTA[]>([]);

  useEffect(() => {
    const buttonTexts = builderData.customCTA.buttonText
      ? builderData.customCTA.buttonText.split("#lcard;")
      : [];
    const buttonLinks = builderData.customCTA.buttonLink
      ? builderData.customCTA.buttonLink.split("#lcard;")
      : [];
    const buttonColor = builderData.customCTA.buttonColor
      ? builderData.customCTA.buttonColor.split("#lcard;")
      : buttonTexts.map((item) => builderData.primaryColor.color);

    let temp: CUSTOMCTA[] = [];

    buttonTexts.forEach((item, index) => {
      if (item && buttonLinks[index])
        temp.push({
          buttonText: item,
          buttonLink: buttonLinks[index],
          buttonColor: buttonColor[index],
        });
    });

    setCtaList(temp);
  }, [builderData.customCTA, builderData.primaryColor.color]);

  return (
    <Grid item container xs={12}>
      <Grid item xs={12} className="mb-4">
        <Button
          onClick={() => setOpenDialog(true)}
          classes={{ root: dashedButtonStyle.root }}
          fullWidth
        >
          <AddIcon /> Custom CTA Button
        </Button>
      </Grid>
      {ctaList.map((cta, index) => (
        <Grid item xs={12} key={index} className="mb-2">
          <Button
            onClick={() => window.open(cta.buttonLink, "_blank")}
            style={{
              backgroundColor: cta.buttonColor,
              color: isWhite(cta.buttonColor || "") ? "#262626" : "#fff",
              border: isWhite(cta.buttonColor || "")
                ? "1px solid rgba(38,38,38,0.5)"
                : "none",
            }}
            className={roundedButtonStyle.root}
            size="large"
            variant="contained"
            color="primary"
            fullWidth
          >
            {cta.buttonText}
          </Button>
        </Grid>
      ))}
      {openDialog && (
        <CustomCTADialog
          isOpen={openDialog}
          onClose={() => setOpenDialog(false)}
          builderType={builderType}
          ctaList={ctaList}
        />
      )}
    </Grid>
  );
};
